import { useParams } from "react-router-dom";

import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";

import { client, table_name } from "./config";
import { BankPositionsFormCard } from "./edit_card";

export function BankPositionsEdit() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <BankPositionsFormCard id={Number(id)} />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={table_name}
          client={client}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
}
